import * as Yup from 'yup';

Yup.addMethod(Yup.array, 'uniqueProp', function (field, message) {
    return this.test('uniqueProp', message, function (array: any) {
        const notunique =
            array.length === new Set(array.map((e: any) => e[field])).size;

        if (notunique !== false) {
            return true;
        }
        const translateToUniqueness = array.findLastIndex(
            (e: any, i: any, m: any) =>
                e &&
                m.some((t: any, d: any) => t[field] === e[field] && d !== i)
        );

        return this.createError({
            path: `${this.path}.${translateToUniqueness}.${field}`,
            message,
        });
    });
});

Yup.addMethod(Yup.array, 'uniqueGroup', function (field, message) {
    return this.test('uniqueGroup', message, function (array: any) {
        const arrayGrouping = array.flatMap((c: any, g: any) =>
            Array.from(c.contacts ?? []).map((d: any, x: any) => ({
                ...d,
                index: g,
                num: x,
            }))
        );

        const notunique =
            arrayGrouping.length ===
            new Set(
                arrayGrouping.map((e: any) => `${e[field]}-${e.index}-${e.num}`)
            ).size;

        if (notunique !== false) {
            return true;
        }
        const translateToUniqueness = arrayGrouping.findLastIndex(
            (e: any, i: any, m: any) =>
                e &&
                m.some((t: any, d: any) => t[field] === e[field] && d !== i)
        );
        const translateToUniqueNumeric = arrayGrouping.at(
            translateToUniqueness
        ).num;
        const translateToPathOfUniq = arrayGrouping.at(
            translateToUniqueness
        ).index;
        return this.createError({
            path: `${this.path}.${translateToPathOfUniq}.contacts.${translateToUniqueNumeric}.${field}`,
            message,
        });
    });
});

/** @constant {ObjectShape} - Yup Object used for validationScheme in Manage Client procedure */
const clientScheme = Yup.object().shape({
    clientName: Yup.string()
        .required('Checklist name must be filled')
        .max(60, 'Checklist name have limitation of 60 characters'),
    clientEmail: Yup.string()
        .email('Invalid Company email')
        .required('Company email is required')
        .max(256, 'Company Email can have a maximum of 256 characters'),
    contactNumber: Yup.number()
        .required('Company phone must be filled')
        .typeError('Company phone must be filled')
        .test(
            'len',
            'Company phone number must be 7 characters at minimum!',
            (val) => {
                if (val === undefined) {
                    return true;
                }
                return val.toString().length >= 7;
            }
        )
        .test(
            'len',
            'Company phone number must be 16 characters at maximum!',
            (val) => {
                if (val === undefined) {
                    return true;
                }
                return val.toString().length <= 16;
            }
        ),
    solicitorCompany: Yup.string()
        .when('solicitorData', {
            is: (val: []) => val.length > 0,
            then: (schema) => schema,
            otherwise: Yup.string()
                .required('Reviewer company name need to be added')
                .test(
                    'len',
                    'Reviewer company name need to be added before submit',
                    (val) => {
                        if (val === undefined) {
                            return true;
                        }
                        return !(val.length < 64);
                    }
                ),
        })
        .max(64, 'Reviewer company name have limitation of 64 characters'),
    solicitorData: Yup.array()
        .of(
            Yup.object().shape({
                clientId: Yup.string(),
                contacts: Yup.array()
                    .of(
                        Yup.object().shape({
                            isAdded: Yup.bool(),
                            isValidate: Yup.bool(),
                            isAddition: Yup.bool(),
                            name: Yup.string()
                                .when('isAdded', {
                                    is: (val: boolean) => val === false,
                                    then: (schema) => schema,
                                    otherwise: Yup.string().required(
                                        'Reviewer name need to be added'
                                    ),
                                })
                                .when('isAddition', {
                                    is: (val: boolean) => val === false,
                                    then: (schema) => schema,
                                    otherwise: Yup.string().required(
                                        'Reviewer name need to be added'
                                    ),
                                })
                                .when('isFocus', {
                                    is: (val: boolean) => val === false,
                                    then: (schema) => schema,
                                    otherwise: Yup.string().required(
                                        'Reviewer name need to be added'
                                    ),
                                })
                                .when('isValidate', {
                                    is: (val: boolean) => val === false,
                                    then: (schema) => schema,
                                    otherwise: Yup.string().when('phone', {
                                        is: (val: number) =>
                                            typeof val === 'undefined' ||
                                            (typeof val === 'number' &&
                                                val === -1),
                                        then: Yup.string().when('email', {
                                            is: (val: string) =>
                                                typeof val === 'undefined',
                                            then: (schema) => schema,
                                            otherwise: Yup.string().required(
                                                'Reviewer name need to be added'
                                            ),
                                        }),
                                        otherwise: Yup.string().when('email', {
                                            is: (val: string) =>
                                                typeof val === 'undefined',
                                            then: Yup.string().required(
                                                'Reviewer name need to be added'
                                            ),
                                            otherwise: Yup.string().required(
                                                'Reviewer name need to be added'
                                            ),
                                        }),
                                    }),
                                })
                                .max(
                                    64,
                                    'Reviewer name have limitation of 64 characters'
                                ),
                            email: Yup.string()
                                .email('Invalid Reviewer email')
                                .when('isAdded', {
                                    is: (val: boolean) => val === false,
                                    then: (schema) => schema,
                                    otherwise: Yup.string().required(
                                        'Reviewer email is required'
                                    ),
                                })
                                .when('isAddition', {
                                    is: (val: boolean) => val === false,
                                    then: (schema) => schema,
                                    otherwise: Yup.string().required(
                                        'Reviewer email is required'
                                    ),
                                })
                                .when('isFocus', {
                                    is: (val: boolean) => val === false,
                                    then: (schema) => schema,
                                    otherwise: Yup.string().required(
                                        'Reviewer email is required'
                                    ),
                                })
                                .when('isValidate', {
                                    is: (val: boolean) => val === false,
                                    then: (schema) => schema,
                                    otherwise: Yup.string().when('phone', {
                                        is: (val: number) =>
                                            typeof val === 'undefined' ||
                                            (typeof val === 'number' &&
                                                val === -1),
                                        then: Yup.string().when('name', {
                                            is: (val: string) =>
                                                typeof val === 'undefined',
                                            then: (schema) => schema,
                                            otherwise: Yup.string().required(
                                                'Reviewer email is required'
                                            ),
                                        }),
                                        otherwise: Yup.string().when('name', {
                                            is: (val: string) =>
                                                typeof val === 'undefined',
                                            then: Yup.string().required(
                                                'Reviewer email is required'
                                            ),
                                            otherwise: Yup.string().required(
                                                'Reviewer email is required'
                                            ),
                                        }),
                                    }),
                                })
                                .max(
                                    256,
                                    'Reviewer Email can have a maximum of 256 characters'
                                ),
                            phone: Yup.number()
                                .transform((value) =>
                                    Number.isNaN(value) ||
                                    value === null ||
                                    value === undefined
                                        ? -1
                                        : value
                                )
                                .when('isAdded', {
                                    is: (val: boolean) => val === false,
                                    then: (schema) => schema,
                                    otherwise: Yup.number()
                                        .required(
                                            'Reviewer phone must be filled'
                                        )
                                        .typeError(
                                            'Reviewer phone must be filled'
                                        )
                                        .test(
                                            'numeric',
                                            'Reviewer phone must be filled',
                                            (val) => {
                                                if (val === -1) {
                                                    return false;
                                                }
                                                return true;
                                            }
                                        ),
                                })
                                .when('isFocus', {
                                    is: (val: boolean) => val === false,
                                    then: (schema) => schema,
                                    otherwise: Yup.number()
                                        .required(
                                            'Reviewer phone must be filled'
                                        )
                                        .typeError(
                                            'Reviewer phone must be filled'
                                        )
                                        .test(
                                            'numeric',
                                            'Reviewer phone must be filled',
                                            (val) => {
                                                if (val === -1) {
                                                    return false;
                                                }
                                                return true;
                                            }
                                        ),
                                })
                                .when('isAddition', {
                                    is: (val: boolean) => val === false,
                                    then: (schema) => schema,
                                    otherwise: Yup.number()
                                        .required(
                                            'Reviewer phone must be filled'
                                        )
                                        .typeError(
                                            'Reviewer phone must be filled'
                                        )
                                        .test(
                                            'numeric',
                                            'Reviewer phone must be filled',
                                            (val) => {
                                                if (val === -1) {
                                                    return false;
                                                }
                                                return true;
                                            }
                                        ),
                                })
                                .when('isValidate', {
                                    is: (val: boolean) => val === false,
                                    then: (schema) => schema,
                                    otherwise: Yup.number().when('name', {
                                        is: (val: string) =>
                                            typeof val === 'undefined',
                                        then: Yup.number().when('email', {
                                            is: (val: string) =>
                                                typeof val === 'undefined',
                                            then: (schema) => schema,
                                            otherwise: Yup.number()
                                                .typeError(
                                                    'Reviewer phone must be filled'
                                                )
                                                .required(
                                                    'Reviewer phone must be filled'
                                                ),
                                        }),
                                        otherwise: Yup.number().when('email', {
                                            is: (val: string) =>
                                                typeof val === 'undefined',
                                            then: Yup.number()
                                                .typeError(
                                                    'Reviewer phone must be filled'
                                                )
                                                .required(
                                                    'Reviewer phone must be filled'
                                                )
                                                .test(
                                                    'numeric',
                                                    'Reviewer phone must be filled',
                                                    (val) => {
                                                        if (val === -1) {
                                                            return false;
                                                        }
                                                        return true;
                                                    }
                                                ),
                                            otherwise: Yup.number()
                                                .typeError(
                                                    'Reviewer phone must be filled'
                                                )
                                                .required(
                                                    'Reviewer phone must be filled'
                                                )
                                                .test(
                                                    'numeric',
                                                    'Reviewer phone must be filled',
                                                    (val) => {
                                                        if (val === -1) {
                                                            return false;
                                                        }
                                                        return true;
                                                    }
                                                ),
                                        }),
                                    }),
                                })
                                .typeError('Reviewer phone must be filled')
                                .test(
                                    'len',
                                    'Reviewer phone number must be 7 characters at minimum!',
                                    (val) => {
                                        if (
                                            val === undefined ||
                                            val === null ||
                                            val === -1
                                        ) {
                                            return true;
                                        }
                                        return val.toString().length >= 7;
                                    }
                                )
                                .test(
                                    'len',
                                    'Reviewer phone number must be 16 characters at maximum!',
                                    (val) => {
                                        if (
                                            val === undefined ||
                                            val === null ||
                                            val === -1
                                        ) {
                                            return true;
                                        }
                                        return val.toString().length <= 16;
                                    }
                                ),
                        })
                    )
                    .uniqueProp(
                        'email',
                        'Selected email must be unique in contacts'
                    ),
            })
        )
        .uniqueGroup('email', 'Selected email must be unique in contacts'),
    SLADays: Yup.number()
        .typeError('Timing to SLA must be filled in days format')
        .required('Timing to SLA must be filled in days format'),
    archiveDays: Yup.number()
        .typeError('Archive cross check in days must be filled')
        .required('Archive cross check in days must be filled')
        .moreThan(0, 'Archive cross check should not be zero'),
    cm9Days: Yup.number()
        .typeError('Timing to CM must be filled in seconds format')
        .required('Timing to CM must be filled in seconds format')
        .max(600, 'Maximum allowed limit is 600 seconds')
        .min(1, 'seconds need to be positive'),
    reworkDays: Yup.number()
        .typeError('Rework in days must be filled')
        .required('Rework in days must be filled')
        .max(100, 'Maximum allowed limit is between 1 to 100 days')
        .min(1, 'days need to be positive ahead'),
});

/** @constant {ObjectShape} - Yup Object extends default clientScheme used for validationScheme in Manage Client with additional checklist validation procedure */
const clientWithChecklistScheme = clientScheme.shape({
    checklist: Yup.string()
        .required('Checklist file must be uploaded')
        .matches(/^.*\.(PDF|pdf)$/, 'file type need to be pdf'),
    checklistName: Yup.string().required('Checklist name must be filled'),
});

export { clientScheme, clientWithChecklistScheme };
